export default "__VITE_PUBLIC_ASSET__88969504__"